import React from "react";

export const Project = ({projectName,projectDescription,img,url})=> {
    return (
        <div class="card overflow-hidden shadow rounded-4 border-0 mb-5">
            <div class="card-body p-0">
                <div class="d-flex align-items-center">
                    <div class="p-5">
                        <h2 class="fw-bolder">{projectName}</h2>
                        <p>{projectDescription}</p>
                        <a class="btn btn-primary px-4 py-3" href={url} target='__blank'>
                           <div class="d-inline-block bi bi-eye me-2"></div>
                           View Project
                        </a>
                    </div>
                    <div>
                      <img style={{maxWidth:"100%"}} src={img} alt="..." />
                    </div>
                </div>
            </div>
        </div>
    )
}